
(() => {
  if (window.__LovenseHomeModulesLoaded) return;
  window.__LovenseHomeModulesLoaded = true;

  const qsa = (root, selector) => Array.from(root.querySelectorAll(selector));

  function initCarousel(root) {
    if (root.dataset.lvReady === 'true') return;
    root.dataset.lvReady = 'true';
    const track = root.querySelector('[data-lv-track]');
    if (!track) return;
    const prev = root.querySelector('[data-lv-prev]');
    const next = root.querySelector('[data-lv-next]');
    const dots = qsa(root, '[data-lv-dot]');
    const items = () => qsa(track, ':scope > *');
    const step = () => {
      const first = items()[0];
      if (!first) return track.clientWidth * .85;
      const styles = getComputedStyle(track);
      return first.getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
    };
    const move = dir => track.scrollBy({ left: step() * dir, behavior: 'smooth' });
    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    const updateDots = () => {
      if (!dots.length) return;
      const children = items();
      if (!children.length) return;
      let best = 0, dist = Infinity;
      children.forEach((item, index) => {
        const d = Math.abs(item.offsetLeft - track.scrollLeft);
        if (d < dist) { dist = d; best = index; }
      });
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === best));
    };
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateDots);
    }, { passive: true });
    dots.forEach((dot, index) => dot.addEventListener('click', () => items()[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })));
    updateDots();
  }

  function initTabs(root) {
    if (root.dataset.lvTabsReady === 'true') return;
    root.dataset.lvTabsReady = 'true';
    const buttons = qsa(root, '[data-lv-tab-button]');
    const panels = qsa(root, '[data-lv-tab-panel]');
    const activate = key => {
      buttons.forEach(btn => {
        const active = btn.dataset.lvTabButton === key;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        btn.tabIndex = active ? 0 : -1;
        if (active) btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      panels.forEach(panel => {
        const active = panel.dataset.lvTabPanel === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };
    buttons.forEach(btn => btn.addEventListener('click', () => activate(btn.dataset.lvTabButton)));
    root.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      const current = buttons.indexOf(document.activeElement);
      if (current < 0) return;
      event.preventDefault();
      let next = current;
      if (event.key === 'ArrowRight') next = (current + 1) % buttons.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + buttons.length) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      buttons[next].focus(); activate(buttons[next].dataset.lvTabButton);
    });
  }

  function initHero(root) {
    if (root.dataset.lvHeroReady === 'true') return;
    root.dataset.lvHeroReady = 'true';
    const slides = qsa(root, '[data-lv-hero-slide]');
    const dots = qsa(root, '[data-lv-hero-dot]');
    if (!slides.length) return;
    let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let timer;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        const video = slide.querySelector('video');
        if (video) active ? video.play().catch(() => {}) : video.pause();
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    const restart = () => {
      clearInterval(timer);
      const seconds = Number(root.dataset.autoplaySeconds || 0);
      if (seconds > 0 && slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(() => show(index + 1), seconds * 1000);
      }
    };
    root.querySelector('[data-lv-hero-prev]')?.addEventListener('click', () => { show(index - 1); restart(); });
    root.querySelector('[data-lv-hero-next]')?.addEventListener('click', () => { show(index + 1); restart(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); restart(); }));
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', restart);
    show(index); restart();
  }

  function initVideoCards(scope) {
    qsa(scope, '[data-lv-video-toggle]').forEach(button => {
      if (button.dataset.lvReady === 'true') return;
      button.dataset.lvReady = 'true';
      button.addEventListener('click', () => {
        const card = button.closest('[data-lv-video-card]');
        const video = card?.querySelector('video');
        if (!video) return;
        if (video.paused) { video.play().catch(() => {}); button.classList.add('is-playing'); }
        else { video.pause(); button.classList.remove('is-playing'); }
      });
    });
  }

  function init(scope = document) {
    qsa(scope, '[data-lv-carousel]').forEach(initCarousel);
    qsa(scope, '[data-lv-tabs]').forEach(initTabs);
    qsa(scope, '[data-lv-hero]').forEach(initHero);
    initVideoCards(scope);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest?.('[data-lv-hero-slide]');
    if (slide) {
      const root = slide.closest('[data-lv-hero]');
      qsa(root, '[data-lv-hero-slide]').forEach((item, i) => item.classList.toggle('is-active', item === slide));
    }
  });
})();
